<app-async-block [inRequest]="(performanceFacade.cntEstInRequest$ | async) === true">
  <app-win-rates-by-cnt-est
    [performanceCntEstData]="(data$ | async) || []"
    [performanceCntEstTotal]="total$ | async"
    [order]="(performanceFacade.cntEstOrder$ | async) || DEFAULT_CNT_EST_ORDER"
    [sortBy]="(performanceFacade.cntEstSortBy$ | async) || DEFAULT_CNT_EST_SORT_BY"
    (changeSort)="changeSort($event.sortBy, $event.order)"
  ></app-win-rates-by-cnt-est>
</app-async-block>
